import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
export async function cargarCuentas() {
  if (!cache) cache = api.get("/bancos/cuentas").then((r) => r.data).catch(() => []);
  return cache;
}
export const invalidarCuentas = () => { cache = null; };

export const UNIDADES = [["almacen_central", "Almacén Central"], ["sucursales", "Sucursales"], ["cedis_oaxaca", "CEDIS Oaxaca"], ["franquicias", "Franquicias"], ["inversionistas", "Proyecto Inversionistas"], ["corporativo", "Corporativo"]];
export const UNIDAD_LABEL = Object.fromEntries(UNIDADES);

export function CuentaBancariaSelect({ value, onChange, testid = "cuenta-bancaria-select", className = "field", placeholder = "¿A qué cuenta bancaria?", required = false, light = false }) {
  const [cuentas, setCuentas] = useState([]);
  useEffect(() => { cargarCuentas().then(setCuentas); }, []);
  if (!cuentas.length) return null; // sucursales y franquicias no ven cuentas bancarias
  return (
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} className={`${className} ${light ? "text-brand-ink" : ""}`} required={required}>
      <option value="">{placeholder}</option>
      {cuentas.map((c) => <option key={c.id} value={c.id}>{c.alias}{c.digitos ? ` ····${c.digitos}` : ""}</option>)}
    </select>
  );
}

export function UnidadSelect({ value, onChange, testid = "unidad-negocio-select", className = "field" }) {
  return <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} className={className}><option value="">Unidad según sucursal</option>{UNIDADES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>;
}
